/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useEnterprise, useCompany, useClient, useTableMaster} from '../../../../hooks'
import {ContractModel} from '../../../../model'
import {getContract} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'

const TableReceptionService: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()

  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {enterprise, getEnterpriseList} = useEnterprise()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList, handleClear} = useClient()
  const {typeReception, getTypeReceptionList} = useTableMaster()

  const getContractList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getContract(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTypeReceptionList()
    getCompanyList()
    getEnterpriseList()
    getClientList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getContractList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getContractList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-ceco',
      },
      idToDelete: '',
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id

    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ContractModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            data={companyList}
            selecteable
          />
        ),
        accessor: 'nombreCompania',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            data={clientList}
            selecteable
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa recepcionadora'
            name={'empresaId'}
            data={enterprise}
            selecteable
          />
        ),
        accessor: 'nombreEmpresa',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo recepcionador'
            name={'tipoRecepcionador'}
            data={typeReception}
            selecteable
          />
        ),
        accessor: 'tipoRecepcionadorNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [companyList, enterprise, typeReception, clientList, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      handleClear()
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TableReceptionService}
